module.exports = __webpack_public_path__ + "static/media/font_bold.c41fbd68.woff2";